// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__2_1t8","my_overlay":"Backdrop_my_overlay__1ZohW"};